// 开发者工具检测和阻止
class DevToolsDetector {
  constructor() {
    this.isDevToolsOpen = false;
    this.checkInterval = null;
    this.init();
  }

  init() {
    // 监听键盘快捷键
    this.preventKeyboardShortcuts();
    
    // 监听右键菜单
    this.preventContextMenu();
    
    // 开始定期检测开发者工具是否真正打开
    this.startDetection();
  }

  startDetection() {
    // 定期检测开发者工具是否真正打开
    this.checkInterval = setInterval(() => {
      this.detectDevTools();
    }, 1000);
  }

  detectDevTools() {
    // 方法1: 检测窗口大小变化
    const threshold = 160;
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    // 方法2: 检测控制台
    let consoleOpened = false;
    const start = performance.now();
    debugger;
    const end = performance.now();
    
    if (end - start > 100) {
      consoleOpened = true;
    }
    
    // 只有当真正检测到开发者工具打开时才处理
    if ((widthThreshold || heightThreshold || consoleOpened) && !this.isDevToolsOpen) {
      this.handleDevToolsOpen();
    } else if (!(widthThreshold || heightThreshold || consoleOpened) && this.isDevToolsOpen) {
      // 开发者工具已关闭，恢复正常状态
      this.handleDevToolsClose();
    }
  }

  preventKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
      // 阻止 F12
      if (e.key === 'F12') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // 阻止 Ctrl+Shift+I (Windows/Linux)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // 阻止 Ctrl+Shift+J (Windows/Linux)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // 阻止 Ctrl+U (查看源代码)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // 阻止 Ctrl+Shift+C (元素检查)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  }

  preventContextMenu() {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }

  handleDevToolsOpen() {
    this.isDevToolsOpen = true;
    this.showWarning();
    this.disablePageFunctionality();
  }

  handleDevToolsClose() {
    this.isDevToolsOpen = false;
    this.enablePageFunctionality();
    this.removeWarning();
  }

  showWarning() {
    // 避免重复创建警告
    if (document.getElementById('dev-tools-warning')) {
      return;
    }

    const warningDiv = document.createElement('div');
    warningDiv.id = 'dev-tools-warning';
    warningDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      font-size: 24px;
      text-align: center;
      font-family: Arial, sans-serif;
    `;
    warningDiv.innerHTML = `
      <div>
        <h2>⚠️ 安全警告</h2>
        <p>检测到开发者工具已打开</p>
        <p>为了系统安全，请关闭开发者工具</p>
        <p>关闭后页面将自动恢复正常</p>
      </div>
    `;
    
    document.body.appendChild(warningDiv);
  }

  removeWarning() {
    const warningDiv = document.getElementById('dev-tools-warning');
    if (warningDiv && warningDiv.parentNode) {
      warningDiv.parentNode.removeChild(warningDiv);
    }
  }

  disablePageFunctionality() {
    // 禁用页面交互
    document.body.style.pointerEvents = 'none';
    document.body.style.userSelect = 'none';
  }

  enablePageFunctionality() {
    // 恢复页面交互
    document.body.style.pointerEvents = '';
    document.body.style.userSelect = '';
  }

  destroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    this.enablePageFunctionality();
    this.removeWarning();
  }
}

// 导出检测器实例
export const devToolsDetector = new DevToolsDetector();

// 默认导出
export default DevToolsDetector; 